import React from 'react';
import { AI_TRAINER_PERSONALITIES } from '../../constants/aiTrainerPersonalities';
import { readingActionButtonClassName } from '../FitnessProfile/shared/fitnessProfileReadingStyles';
import { aiTrainerHeadingClassName } from './aiTrainerStyles';

export default function AiTrainerCoachHeader({ personality, onOpenCoachKnowledge, onOpenSettings }) {
	const persona = AI_TRAINER_PERSONALITIES.find((item) => item.id === personality);

	return (
		<div className="min-w-0 flex-1 md:flex md:items-center md:gap-2.5">
			<h1 className={`text-2xl sm:text-3xl font-semibold tracking-tight ${aiTrainerHeadingClassName}`}>
				AI Trainer
			</h1>
			{(persona || onOpenCoachKnowledge || onOpenSettings) && (
				<div className="mt-2 flex items-center gap-2 md:mt-0">
					{persona && (
						<span className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 dark:border-dark-border bg-gray-50 dark:bg-dark-bg px-3 py-1 text-xs font-medium text-gray-700 dark:text-dark-text">
							<span aria-hidden="true">{persona.emoji}</span>
							{persona.label}
						</span>
					)}
					{(onOpenCoachKnowledge || onOpenSettings) && (
						<span className="inline-flex shrink-0 -translate-y-0.5 items-center gap-1.5">
							{onOpenCoachKnowledge && (
								<button
									type="button"
									onClick={onOpenCoachKnowledge}
									className={readingActionButtonClassName}
									aria-label="What my coach knows"
									title="What my coach knows"
								>
									<i className="fa-solid fa-circle-info text-sm" aria-hidden="true" />
								</button>
							)}
							{onOpenSettings && (
								<button
									type="button"
									onClick={onOpenSettings}
									className={readingActionButtonClassName}
									aria-label="Trainer settings"
									title="Trainer settings"
								>
									<i className="fa-solid fa-gear text-sm" aria-hidden="true" />
								</button>
							)}
						</span>
					)}
				</div>
			)}
		</div>
	);
}
